import { atomWithStorage, createJSONStorage } from "jotai/utils";

export const returnToAtom = atomWithStorage<string | null>(
  "returnTo",
  null,
  createJSONStorage(() => sessionStorage),
  { getOnInit: true },
);
